export default __webpack_public_path__ + "strongher-devices.399883b2.png";